import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="features"
export default class extends Controller {
  static targets = ["list"];

  connect() {
    console.log("FeaturesController connected!");
  }

  add(event) {
    console.log("Add feature clicked!");
    event.preventDefault();
    const div = document.createElement('div');
    div.className = 'flex items-center mb-2 feature-row';
    div.innerHTML = `<input type=\"text\" name=\"subscription_plan[features_array][]\" class=\"w-full rounded-lg border-slate-200 dark:border-slate-600 dark:bg-slate-700/50 dark:text-white mr-2\" />\n      <button type=\"button\" data-action=\"features#remove\" class=\"remove-feature bg-red-500 text-white rounded px-2 py-1 ml-2\">&times;</button>`;
    this.listTarget.appendChild(div);
  }

  remove(event) {
    console.log("Remove feature clicked!");
    event.preventDefault();
    event.target.parentElement.remove();
  }
}
